import { createContext, useContext } from 'react'

export interface ThemeState {
  darkMode: boolean
}

export const INITIAL_STATE: ThemeState = {
  darkMode: false
}

export const ThemeContext = createContext(INITIAL_STATE)

export const useThemeContext = () => useContext(ThemeContext)
